function band(value,{good=null,warn=null,inverse=false}={}){
  if(value==null||!Number.isFinite(Number(value)))return{state:'MISSING',value:null};
  const v=Number(value);
  if(good!=null){const hit=inverse?v<=good:v>=good;if(hit)return{state:'SUPPORTIVE',value:v};}
  if(warn!=null){const hit=inverse?v>=warn:v<=warn;if(hit)return{state:'CAUTION',value:v};}
  return{state:'MIXED',value:v};
}
const N=v=>v==null||!Number.isFinite(Number(v))?null:Number(v);
const pctChange=(current,previous)=>{const c=N(current),p=N(previous);return c==null||p==null||p===0?null:(c-p)/Math.abs(p)*100};
const delta=(current,previous)=>{const c=N(current),p=N(previous);return c==null||p==null?null:c-p};
function trendBand(value,{improve,deteriorate}){
  if(value==null||!Number.isFinite(Number(value)))return{state:'MISSING',value:null};
  const v=Number(value);
  if(v>=improve)return{state:'IMPROVING',value:v};
  if(v<=deteriorate)return{state:'DETERIORATING',value:v};
  return{state:'STABLE',value:v};
}
function fcfTrend(current,previous){
  const c=N(current),p=N(previous);
  if(c==null||p==null)return{state:'MISSING',value:null};
  if(p<=0&&c>0)return{state:'TURNED_POSITIVE',value:null};
  if(p>0&&c<=0)return{state:'TURNED_NEGATIVE',value:null};
  const change=pctChange(c,p);
  return trendBand(change,{improve:15,deteriorate:-15});
}
function aggregateTrend(trends){
  const states=Object.values(trends).map(x=>x.state).filter(x=>x!=='MISSING');
  const improving=states.filter(x=>['IMPROVING','TURNED_POSITIVE'].includes(x)).length;
  const deteriorating=states.filter(x=>['DETERIORATING','TURNED_NEGATIVE'].includes(x)).length;
  if(states.length<2)return{state:'MISSING',observed:states.length,improving,deteriorating};
  if(deteriorating>=2)return{state:'DETERIORATING',observed:states.length,improving,deteriorating};
  if(improving>=2&&deteriorating===0)return{state:'IMPROVING',observed:states.length,improving,deteriorating};
  if(improving===0&&deteriorating===0)return{state:'STABLE',observed:states.length,improving,deteriorating};
  return{state:'MIXED',observed:states.length,improving,deteriorating};
}

export function deriveCompanyQualityEvidence(secFinancials){
  const m=secFinancials?.metrics||{},p=secFinancials?.previousMetrics||{};
  const available=secFinancials?.status==='VERIFIED'||secFinancials?.status==='PARTIAL';
  if(!available)return{status:'MISSING',source:'SEC Company Facts',fiscalEnd:null,previousFiscalEnd:null,signals:{},trends:{},trend:{state:'MISSING',observed:0,improving:0,deteriorating:0}};
  const cashConversion=m.operatingCashFlowAnnual!=null&&m.netIncomeAnnual!=null&&m.netIncomeAnnual!==0?m.operatingCashFlowAnnual/m.netIncomeAnnual:null;
  const debtToFcf=m.totalDebt!=null&&m.freeCashFlowAnnual!=null&&m.freeCashFlowAnnual>0?m.totalDebt/m.freeCashFlowAnnual:null;
  const signals={
    grossMargin:band(m.grossMarginPct,{good:40,warn:15}),
    operatingMargin:band(m.operatingMarginPct,{good:15,warn:5}),
    freeCashFlow:{state:m.freeCashFlowAnnual==null?'MISSING':m.freeCashFlowAnnual>0?'SUPPORTIVE':'CAUTION',value:m.freeCashFlowAnnual??null},
    cashConversion:band(cashConversion,{good:1,warn:0.7}),
    leverage:band(debtToFcf,{good:2,warn:5,inverse:true})
  };
  const trends={
    revenue:trendBand(pctChange(m.revenueAnnual,p.revenueAnnual),{improve:10,deteriorate:-10}),
    grossMargin:trendBand(delta(m.grossMarginPct,p.grossMarginPct),{improve:2,deteriorate:-2}),
    operatingMargin:trendBand(delta(m.operatingMarginPct,p.operatingMarginPct),{improve:2,deteriorate:-2}),
    freeCashFlow:fcfTrend(m.freeCashFlowAnnual,p.freeCashFlowAnnual)
  };
  const trend=aggregateTrend(trends);
  const observed=Object.values(signals).filter(x=>x.state!=='MISSING').length;
  return{
    status:observed>=4?'EVIDENCE':'PARTIAL',
    source:'SEC Company Facts',
    fiscalEnd:secFinancials.fiscalEnd||null,
    previousFiscalEnd:secFinancials.previousFiscalEnd||null,
    filedAt:secFinancials.filedAt||null,
    signals,
    trends,
    trend,
    rawMetrics:m,
    previousMetrics:p,
    note:'Evidence bridge only. Current quality and prior-year trend remain separate; trend cannot create Company Quality, BUY/SELL, or capital permission by itself.'
  };
}
